var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ModelTraits from "../ModelTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
import Quaternion from "terriajs-cesium/Source/Core/Quaternion";
import HeadingPitchRoll from "terriajs-cesium/Source/Core/HeadingPitchRoll";
import updateModelFromJson from "../../Models/Definition/updateModelFromJson";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
// Scratch variables used to avoid repeated object instantiation
const hprScratch = new HeadingPitchRoll();
const quaternionScratch = new Quaternion();
let HeadingPitchRollTraits = (_dec = primitiveTrait({
  type: "number",
  name: "Heading",
  description: "Heading in degrees"
}), _dec2 = primitiveTrait({
  type: "number",
  name: "Pitch",
  description: "Pitch in degrees"
}), _dec3 = primitiveTrait({
  type: "number",
  name: "Roll",
  description: "Roll in degrees"
}), _class = class HeadingPitchRollTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "heading", _descriptor, this);
    _initializerDefineProperty(this, "pitch", _descriptor2, this);
    _initializerDefineProperty(this, "roll", _descriptor3, this);
  }
  static setFromRotationMatrix(model, stratumId, rotation) {
    this.setFromHeadingPitchRoll(model, stratumId, HeadingPitchRoll.fromQuaternion(Quaternion.fromRotationMatrix(rotation, quaternionScratch), hprScratch));
  }
  static setFromQuaternion(model, stratumId, rotation) {
    this.setFromHeadingPitchRoll(model, stratumId, HeadingPitchRoll.fromQuaternion(rotation, hprScratch));
  }
  static setFromHeadingPitchRoll(model, stratumId, hpr) {
    updateModelFromJson(model, stratumId, {
      heading: CesiumMath.toDegrees(hpr.heading),
      pitch: CesiumMath.toDegrees(hpr.pitch),
      roll: CesiumMath.toDegrees(hpr.roll)
    }).logError("Error ocurred while setting heading, pitch and roll");
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "heading", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pitch", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "roll", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { HeadingPitchRollTraits as default };